import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Scheduling, Schedulings } from 'src/app/types/scheduling/scheduling.type';
import { Id } from 'src/app/models/database/types/id.model';
import { HttpService } from '../http-service.service';
import { AddScheduling, SchedulingFilter } from 'src/app/types/scheduling';

@Injectable({
  providedIn: 'root'
})
export class SchedulingService extends HttpService {

  constructor(private http: HttpClient) {
    super('scheduling')
  }

  registerAppointment(scheduling: AddScheduling): Observable<void> {
    return this.http.post<void>(this.url, { scheduling })
  }

  getSchedulings(scheduleId: Id, filter?: SchedulingFilter): Observable<Schedulings> {
    let url: string = `${this.url}/schedule/${scheduleId}`
    if (filter) {
      url += this.implementQueries(filter)
    }
    return this.http.get<Schedulings>(url)
  }

  getScheduling(schedulingId: Id): Observable<Scheduling> {
    return this.http.get<Scheduling>(`${this.url}/${schedulingId}`)
  }

  getSchedulingByUuid(uuid: string): Observable<Scheduling> {
    return this.http.get<Scheduling>(`${this.url}/uuid/${uuid}`)
  }

  getAvailableTimes(scheduleId: number, date: string, schedulingId?: number): Observable<string[]> {
    let url: string = `${this.url}/hours-available?scheduleId=${scheduleId}&date=${date}`
    if (schedulingId) {
      url += `&schedulingId=${schedulingId}`
    }
    return this.http.get<string[]>(url)
  }

  getCancelmentReasons(): Observable<{ id: Id, desc: string }[]> {
    return this.http.get<{ id: Id, desc: string }[]>(`${this.url}/cancelment-reasons`)
  }

  edit(schedulingId: Id, scheduling: Scheduling): Observable<void> {
    return this.http.put<void>(`${this.url}/${schedulingId}`, { scheduling })
  }

  cancelScheduling(schedulingId: Id, cancelmentDetails: any): Observable<void> {
    return this.http.delete<void>(`${this.url}/${schedulingId}`)
  }

  validateDate(scheduleId: number, date: string): Observable<void> {
    return this.http.head<void>(`${this.url}/validate-date?scheduleId=${scheduleId}&date=${date}`)
  }

  validateTime(scheduleId: number, date: string, time: string, schedulingId?: number): Observable<void> {
    let url: string = `${this.url}/can-fit?scheduleId=${scheduleId}&date=${date}&hour=${time}`
    if (schedulingId) {
      url += `&schedulingId=${schedulingId}`
    }
    return this.http.head<void>(url)
  }
}
